'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessageGroup = getMessageGroup;

var _PubNubMessageGroups = require('../../constants/PubNubMessageGroups');

var _PubNubMessageGroups2 = _interopRequireDefault(_PubNubMessageGroups);

var _isUnpublished = require('./isUnpublished');

var _isSimulated = require('./isSimulated');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getMessageGroup(message) {
  if ((0, _isUnpublished.isUnpublished)(message) || (0, _isSimulated.isSimulated)(message)) {
    return _PubNubMessageGroups2.default.PUBLISHING;
  }
  return _PubNubMessageGroups2.default.HISTORY;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/getMessageGroup.js
// module id = 889
// module chunks = 2 3